import { useHistory } from 'quartz-routing/react-router';
import { useCallback } from 'react';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { NavMarker } from 'react-rhumb';
import TrackPage from '../../components/TrackPage/TrackPage';
// @ts-expect-error Could not find a declaration file for module
import TrackDeprecatedModal from '../../components/Modals/FeatureIntroModals/TrackDeprecatedModal';
import { isTrackDeprecated } from '../../utils/utils.migrated';
import { getNextContentUrl } from '../../features/tracks/tracksRouting';
import { usePlaylistIdFromSearch } from '../../features/playlistContent/hooks.migrated';
import { useLessonPreQuizSession } from '../../features/preAssessmentQuiz/hooks/useLessonPreQuiz.migrated';
import { getFocusContentId, isPreAssessmentCompleted } from '../../features/preAssessmentQuiz/utils/preAssessmentQuizUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackPageContainer = ({
  track,
  trackProgress,
  lesson,
  content,
  contentFragment,
  contentProgress,
  lessonProgress
}) => {
  const {
    location
  } = useHistory();
  const navigate = useACNavigate();
  const isInPlaylist = !!usePlaylistIdFromSearch();
  const {
    getLessonPreQuizState
  } = useLessonPreQuizSession();
  const handleAdvanceContent = useCallback(() => {
    if (!content || !lesson) {
      return;
    }
    navigate(Object.assign({}, location, {
      pathname: getNextContentUrl({
        track,
        lesson,
        contentId: content.id,
        isInPlaylist,
        getLessonPreQuizState
      })
    }));
  }, [content, lesson, track, isInPlaylist, location, getLessonPreQuizState, navigate]);
  const handleSkipPreAssessment = useCallback(() => lesson ? navigate(Object.assign({}, location, {
    pathname: `/tracks/${track.id}/${lesson.id}`
  })) : navigate(Object.assign({}, location, {
    pathname: `/tracks/${track.id}`
  })), [location, track, lesson, navigate]);
  const handleStartLessonWithPreAssessmentFocus = useCallback(() => {
    if (lesson) {
      const preQuizState = getLessonPreQuizState(lesson.id);
      if (preQuizState && isPreAssessmentCompleted(preQuizState)) {
        const firstFocusId = getFocusContentId({
          lessonContent: lesson.content,
          perContentScores: preQuizState.perContentScores
        });
        if (firstFocusId) {
          navigate(Object.assign({}, location, {
            pathname: `/tracks/${track.id}/${lesson.id}/${firstFocusId}`
          }));
          return;
        }
      }
      navigate(Object.assign({}, location, {
        pathname: `/tracks/${track.id}/${lesson.id}`
      }));
    }
  }, [navigate, location, track, lesson, getLessonPreQuizState]);
  const isDeprecated = isTrackDeprecated(track.deprecated, track.deprecationFinalDate);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "COURSE_VIEW_LOADED",
    children: [/*#__PURE__*/_jsx(TrackPage, {
      content: content,
      contentFragment: contentFragment,
      contentProgress: contentProgress,
      lesson: lesson,
      lessonProgress: lessonProgress,
      onAdvanceContent: handleAdvanceContent,
      onSkipPreAssessment: handleSkipPreAssessment,
      onStartLessonWithPreAssessmentFocus: handleStartLessonWithPreAssessmentFocus,
      track: track,
      trackProgress: trackProgress
    }), isDeprecated && /*#__PURE__*/_jsx(TrackDeprecatedModal, {
      cta: track.deprecationCta,
      message: track.deprecationMessage,
      trackId: track.id
    })]
  });
};
export default TrackPageContainer;